export default __webpack_public_path__ + "static/media/Suivi-1-4.4fad625f.gif";